import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const checkboxRootFn = /* @__PURE__ */ createRecipe('checkbox-root', {}, [])

const checkboxRootVariantMap = {}

const checkboxRootVariantKeys = Object.keys(checkboxRootVariantMap)

export const checkboxRoot = /* @__PURE__ */ Object.assign(memo(checkboxRootFn.recipeFn), {
  __recipe__: true,
  __name__: 'checkboxRoot',
  __getCompoundVariantCss__: checkboxRootFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: checkboxRootVariantKeys,
  variantMap: checkboxRootVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, checkboxRootVariantKeys)
  },
  getVariantProps: checkboxRootFn.getVariantProps,
})